module.exports = __webpack_public_path__ + "assets/asset_target.53062b51.svg";